export const buildLocationLabel = (item) => `${item.name} / ${item.eng_name}`;

export const mapLocationOptions = (items) => (items ?? []).map((item) => {
  const label = buildLocationLabel(item);
  return { value: label, label };
});

export const mapSettlementOptions = (items) => (items ?? []).map((item) => {
  const label = buildLocationLabel(item);
  return { value: item.code || label, label };
});

export const buildSettlementValue = (name, code) => (name
  ? { value: code || name, label: name }
  : null);

export const findSettlementCodeByName = (options, name) => {
  const matches = (options ?? []).filter((option) => option.label === name);
  return matches.length === 1 ? matches[0].value : '';
};
